import React from 'react';
import { Star, Music, XCircle, CheckCircle, User } from 'lucide-react';
function StarRating() {
  return <div className="flex gap-0.5 mb-3" data-id="element-347">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-348" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-349">
      <div className="max-w-4xl mx-auto" data-id="element-350">
        {/* Title */}
        <div className="text-center mb-10 md:mb-14" data-id="element-351">
          <p className="font-nunito font-bold text-orange-500 text-base md:text-lg uppercase tracking-widest mb-2 flex items-center justify-center gap-2" data-id="element-352">
            <Star className="w-5 h-5 fill-orange-400" data-id="element-353" /> Lo que dicen los
            maestros
          </p>
          <h2 className="font-nunito font-black text-gray-900 text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-354">
            MÁS DE <span className="text-purple-700" data-id="element-355">1,200 MAESTROS</span> LO
            USAN
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4" data-id="element-356">
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-357" />
            <Music className="w-6 h-6 text-orange-400" data-id="element-358" />
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-359" />
          </div>
          <p className="text-gray-600 font-semibold mt-4" data-id="element-360">
            89% lo sigue usando cada año
          </p>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-12" data-id="element-361">
          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl p-6 border border-orange-200" data-id="element-362">
            <StarRating data-id="element-363" />
            <blockquote className="text-gray-800 font-semibold text-lg leading-relaxed mb-4" data-id="element-364">
              "En UNA hora tenía mi{' '}
              <span className="text-orange-600 font-black" data-id="element-365">
                TRIMESTRE de música listo
              </span>
              "
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-366">
              <div className="w-10 h-10 rounded-full bg-orange-400 flex items-center justify-center text-white font-black text-lg" data-id="element-367">
                R
              </div>
              <div data-id="element-368">
                <p className="font-nunito font-black text-gray-900" data-id="element-369">
                  Maestra Rosa
                </p>
                <p className="text-gray-500 text-sm" data-id="element-370">Puebla, México</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl p-6 border border-purple-200" data-id="element-371">
            <StarRating data-id="element-372" />
            <blockquote className="text-gray-800 font-semibold text-lg leading-relaxed mb-4" data-id="element-373">
              "Mis alumnos{' '}
              <span className="text-purple-600 font-black" data-id="element-374">
                PIDEN la clase de música
              </span>{' '}
              ahora"
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-375">
              <div className="w-10 h-10 rounded-full bg-purple-500 flex items-center justify-center text-white font-black text-lg" data-id="element-376">
                M
              </div>
              <div data-id="element-377">
                <p className="font-nunito font-black text-gray-900" data-id="element-378">
                  Prof. Miguel
                </p>
                <p className="text-gray-500 text-sm" data-id="element-379">CDMX, México</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-6 border border-green-200" data-id="element-380">
            <StarRating data-id="element-381" />
            <blockquote className="text-gray-800 font-semibold text-lg leading-relaxed mb-4" data-id="element-382">
              "Finalmente evaluaciones que{' '}
              <span className="text-green-600 font-black" data-id="element-383">FUNCIONAN</span>"
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-384">
              <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white font-black text-lg" data-id="element-385">
                L
              </div>
              <div data-id="element-386">
                <p className="font-nunito font-black text-gray-900" data-id="element-387">
                  Maestra Laura
                </p>
                <p className="text-gray-500 text-sm" data-id="element-388">Guadalajara, México</p>
              </div>
            </div>
          </div>
        </div>

        {/* Before/After comparison */}
        <div className="bg-gray-900 rounded-3xl p-6 md:p-10" data-id="element-389">
          <h3 className="font-nunito font-black text-white text-xl md:text-3xl text-center mb-6 md:mb-8 flex items-center justify-center gap-2" data-id="element-390">
            <Music className="w-6 h-6 text-yellow-300" data-id="element-391" />
            LUNES 7:45 AM — La diferencia
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-392">
            <div className="bg-red-900/40 border border-red-500/50 rounded-2xl p-6" data-id="element-393">
              <h4 className="font-nunito font-black text-red-400 text-xl mb-4 flex items-center gap-2" data-id="element-394">
                <XCircle className="w-5 h-5" data-id="element-395" /> ANTES:
              </h4>
              <ul className="space-y-3" data-id="element-396">
                {['Entra la clase de música', 'TÚ: "¿Qué hago hoy?"', 'Improvisas toda la hora', 'Alumnos aburridos, sin aprender', 'TÚ: Estrés, inseguridad'].map(item => <li key={item} className="flex items-start gap-2 text-gray-300" data-id="element-397">
                    <span className="text-red-400 mt-1 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-red-400 mt-2" data-id="element-398" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-green-900/40 border border-green-500/50 rounded-2xl p-6" data-id="element-399">
              <h4 className="font-nunito font-black text-green-400 text-xl mb-4 flex items-center gap-2" data-id="element-400">
                <CheckCircle className="w-5 h-5" data-id="element-401" /> CON EL eBook:
              </h4>
              <ul className="space-y-3" data-id="element-402">
                {['Abres PDF semana 1', 'TIENES: Objetivo, actividades, canción, evaluación', 'Imprimes rúbrica (2 minutos)', 'Alumnos cantan, se mueven, aprenden', 'TÚ: Tranquilo, en control, cumples SEP'].map(item => <li key={item} className="flex items-start gap-2 text-gray-300" data-id="element-403">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-green-400 mt-2" data-id="element-404" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="font-nunito font-black text-yellow-300 text-xl text-center mt-8" data-id="element-405">
            ESO ES POSIBLE. Pero solo si tienes los planes.
          </p>
        </div>
      </div>
    </section>;
}